import { vendorPanelApi } from '@/services/vendorPanelApi'

export {
  CATEGORY_SUGGEST_VALUE,
  isCategorySuggestValue,
  primaryCategoryOptions,
  secondaryCategoryOptions,
} from '@/utils/adCategoryOptions'

let cachedCategories = null

/**
 * @returns {Promise<Array<{ value: number, text: string, parentId: number|null }>>}
 */
export async function fetchAdCategories(forceRefresh = false) {
  if (cachedCategories && !forceRefresh) {
    return cachedCategories
  }

  const response = await vendorPanelApi.categories()
  // API: { data: { categories: [...] } } — not a bare array under data
  const rows = response?.data?.data?.categories ?? response?.data?.data
  const list = Array.isArray(rows) ? rows : []

  cachedCategories = list.map(item => {
    const parentRaw = item.parent_id != null ? Number(item.parent_id) : null
    return {
      value: Number(item.id),
      text: String(item.name || '').trim(),
      parentId: Number.isFinite(parentRaw) && parentRaw > 0 ? parentRaw : null,
    }
  }).filter(item => item.value > 0 && item.text)

  return cachedCategories
}

export function clearAdCategoriesCache() {
  cachedCategories = null
}
